import React from 'react';
export function HeroSection() {
  return <section aria-label="Presentación del ProfePack" className="bg-brand-dark text-white md:pt-20 pb-16 md:pb-24 px-4 relative pt-[10px]" data-id="element-134">
      <div className="max-w-5xl mx-auto relative z-10 w-full flex flex-col items-center text-center" data-id="element-135">
        <div className="flex flex-col items-center w-full" data-id="element-136">
          <div className="flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-2 md:mb-8" data-id="element-137">
            <span className="text-xl" aria-hidden="true" data-id="element-138">
              🧮
            </span>{' '}
            PROFEPACK
          </div>

          <h1 className="sm:text-4xl md:text-7xl lg:text-8xl tracking-tight px-2 text-[40px] font-[900] font-sans pl-[0px] pr-[0px] mt-[-10px] mb-[-10px] md:mt-[-20px] md:mb-[-20px] leading-[0.95]" data-id="element-139">
            Todo tu año de Matemática
            <br data-id="element-140" />
            <span className="text-brand-accent" data-id="element-141">resuelto.</span>
          </h1>
        </div>

        <div className="w-full max-w-[270px] sm:max-w-sm md:max-w-xl mx-auto relative mt-4 md:mt-12 mb-3 md:mb-12" data-id="element-142">
          <img src="https://cdn.magicpatterns.com/uploads/p5uukvc9r3hYXLcg8oon7N/PROYECTOS-Anuales-_1080-x-900-px_-_5_.webp" alt="Megapack Matemática Lista — 12 tomos completos para docentes de primaria y secundaria" className="w-full h-auto object-contain relative z-10" loading="eager" decoding="async" fetchPriority="high" sizes="(max-width: 640px) 270px, (max-width: 768px) 384px, 576px" width={1080} height={900} data-id="element-143" />
        </div>

        <div className="flex flex-col items-center w-full max-w-3xl" data-id="element-144">
          <p className="text-base sm:text-xl md:text-3xl text-brand-accent font-heading font-bold md:mb-6 px-2 mb-[2px]" data-id="element-145">
            "Listo para usar. Sin buscar más."
          </p>

          <p className="text-sm md:text-xl text-white/80 md:mb-10 leading-relaxed px-2 mb-[6px]" data-id="element-146">
            El sistema que usan +2.000 docentes de Matemática de primaria y
            secundaria en Argentina para planificar{' '}
            <span className="text-white font-bold" data-id="element-147">
              todo el año en una tarde
            </span>{' '}
            — sin improvisar, sin buscar y sin perder domingos.
          </p>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-4 mb-3 md:mb-10" data-id="element-148">
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90" data-id="element-149">
              📄 100% PDF
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90" data-id="element-150">
              ⚡ Acceso inmediato
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90" data-id="element-151">
              🇦🇷 Currículo argentino 2026
            </span>
          </div>

          <a href="#pricing" onClick={e => {
          e.preventDefault();
          const el = document.getElementById('pricing');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          } else {
            let attempts = 0;
            const interval = setInterval(() => {
              attempts++;
              const target = document.getElementById('pricing');
              if (target) {
                clearInterval(interval);
                target.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              } else if (attempts > 30) {
                clearInterval(interval);
                window.location.hash = 'pricing';
              }
            }, 100);
          }
        }} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-dim active:scale-95 text-brand-dark font-black md:text-3xl py-4 md:py-6 px-6 md:px-14 rounded-2xl transition-colors flex items-center justify-center md:mb-8 mx-4 sm:mx-0 text-[16px] mb-[12px] ml-[20px] mr-[20px] no-underline cursor-pointer" data-id="element-152">
            🧮 → QUIERO MI PROFEPACK AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-x-4 md:gap-x-8 gap-y-2 text-xs md:text-sm text-white/70 font-medium" data-id="element-153">
            <span data-id="element-154">🛡️ Garantía 7 días sin preguntas</span>
            <span data-id="element-155">🔒 Pago 100% seguro</span>
            <span data-id="element-156">💳 Mercado Pago</span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 md:mt-24 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" data-id="element-157">
          <div className="text-center" data-id="element-158">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-159">
              +2.000
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-160">
              docentes confían
            </div>
          </div>
          <div className="text-center" data-id="element-161">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-162">
              12
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-163">
              Tomos completamente listos
            </div>
          </div>
          <div className="text-center" data-id="element-164">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-165">
              4.9/5 ⭐
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-166">
              calificación
            </div>
          </div>
          <div className="text-center" data-id="element-167">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-168">
              🇦🇷
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-169">
              Todo el país — primaria y secundaria
            </div>
          </div>
        </div>

        {/* Hero Testimonials */}
        <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-170">
          {[{
          initials: 'MG',
          name: 'Mariela G.',
          loc: 'Córdoba | Primaria',
          quote: 'Organicé todo el año de Matemática en una tarde'
        }, {
          initials: 'LP',
          name: 'Laura P.',
          loc: 'Rosario | Secundaria',
          quote: 'Mis clases de secundaria por fin tienen estructura real'
        }, {
          initials: 'RM',
          name: 'Roberto M.',
          loc: 'Buenos Aires | Primaria y Sec.',
          quote: 'Nunca más llegué a clase sin saber qué dar'
        }].map((test, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" data-id="element-171">
              <div className="flex items-center gap-3 mb-3" data-id="element-172">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" aria-hidden="true" data-id="element-173">
                  {test.initials}
                </div>
                <span className="text-brand-accent text-sm" aria-label="5 estrellas" data-id="element-174">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
              <p className="text-white/90 font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-175">
                "{test.quote}"
              </p>
              <div className="text-[10px] md:text-xs text-white/70 uppercase tracking-wider font-bold" data-id="element-176">
                — {test.name}, {test.loc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}